import { css } from '@emotion/react';

export const buyerRegistrationPanelStyles = {
  title: css`
    font-size: 32px;
    font-weight: 500;
    line-height: 38px;
    margin-bottom: 5px;
    text-align: center;
  `,
  inputField: css`
    width: 50%;
    padding: 0px 8px;
    margin-bottom: 12px;

    @media (max-width: 425px) {
      width: 100%;
    }

    input {
      width: 100%;
    }

    label {
      font-size: 12px;
      font-weight: 600;
      display: block;
      margin-bottom: 3px;
      cursor: pointer;
    }
  `,
  invalid: css`
    color: #9e3c3c;
  `,
  passwordRequirements: css`
    font-size: 12px;
    margin: 3px 0 0;
    padding: 0;
    li {
      list-style: inside;
    }
  `,
  nestedPasswordRequirements: css`
    padding-left: 20px;
  `,
  agreements: css`
    padding: 0 8px;
    margin-bottom: 12px;
  `,
  actionBar: css`
    display: flex;
    padding: 0 96px;

    @media (max-width: 425px) {
      padding: 0;
    }

    button {
      flex-grow: 1;
      flex-shrink: 1;
      min-height: 41.6px;
    }

    a {
      flex-grow: 3;
    }
  `,
};
